import { useTranslation } from 'react-i18next'
import { isRichTextEmpty } from '@/pages/centrumSzkolen/Projekty/common/ProjectRichTextEditor'

export default function MyProjectOpisSection({ opis = '' }) {
	const { t } = useTranslation()
	const isEmpty = isRichTextEmpty(opis)

	return (
		<div className="mt-6 rounded-md border border-gray-200 bg-white px-6 py-6 shadow-sm sm:px-8 sm:py-8">
			<h2 className="text-sm font-semibold text-gray-900">
				{t('projects.form.fields.description', { defaultValue: 'Opis' })}
			</h2>
			{isEmpty ? (
				<p className="mt-4 px-2 py-3 text-sm text-gray-500 sm:px-4 sm:py-4">
					{t('myProjects.details.emptyOpis', { defaultValue: 'Brak opisu projektu.' })}
				</p>
			) : (
				<div
					className="project-opis-content mt-4 px-2 py-3 text-sm text-gray-700 sm:px-4 sm:py-4 [&_a]:text-indigo-600 [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5 [&_p]:mb-2"
					dangerouslySetInnerHTML={{ __html: opis }}
				/>
			)}
		</div>
	)
}
